import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import useLoanOfficerSettings from 'reducers/hooks/useLoanOfficerSettings';
import { getServerError } from 'utils/errors';
import { getOfferingsOptions } from 'presenters/OfferingPresenter';
import UserPresenter from 'presenters/UserPresenter';
import useApp from 'reducers/hooks/useApp';
import Loader from 'sharedComponents/Loader';
import Alert from 'sharedComponents/Alert';
import Title from '../Title';
import ProfileForm from './components/ProfileForm';
import useStyles from './useStyles';

const Profile = props => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { onBack, offerings, isLoadingOfferings } = props;
  const { requestProfileReview } = useLoanOfficerSettings();
  const {
    updateLoanOfficer,
    saveProfileImage,
    saveCompanyLogo,
    isUpdating,
    currentUser,
    saveProfileVideo,
    isProfileCompanyLogoSaving,
    isProfileImageSaving,
  } = useApp();

  const [alert, setAlert] = useState({ isShow: false, text: '', severity: '' });
  const handleCloseAlert = () => {
    setAlert({ ...alert, isShow: false });
  };

  const offeringsOptions = getOfferingsOptions(offerings);

  const handleSubmit = async values => {
    try {
      const attr = UserPresenter.buildUserUpdateAttributes(currentUser, values);
      await updateLoanOfficer(attr);
    } catch (error) {
      const message = getServerError(error);
      setAlert({ isShow: true, text: message, severity: 'error' });
    }
  };

  const handleSaveProfileImage = async profileImage => {
    const attr = { profileImage };
    await saveProfileImage(attr);
  };

  const handleSaveCompanyLogo = async companyLogoImage => {
    const attr = { companyLogoImage };
    await saveCompanyLogo(attr);
  };

  const handleRequestProfileReview = async () => {
    await requestProfileReview();
  };

  const handleSaveProfileVideo = async attrs => {
    await saveProfileVideo(attrs);
  };

  const title = t('components.LoanOfficerSettings.title.profile');

  if (isUpdating) return <Loader fullFill />;

  return (
    <div className={classes.container}>
      <Title text={title} onBack={onBack} />
      <ProfileForm
        onSubmit={handleSubmit}
        currentUser={currentUser}
        offerings={offeringsOptions}
        onRequestProfileReview={handleRequestProfileReview}
        onSaveProfileVideo={handleSaveProfileVideo}
        isLoadingOfferings={isLoadingOfferings}
        saveProfileImage={handleSaveProfileImage}
        isProfileImageSaving={isProfileImageSaving}
        saveCompanyLogo={handleSaveCompanyLogo}
        isProfileCompanyLogoSaving={isProfileCompanyLogoSaving}
      />
      <Alert text={alert.text} open={alert.isShow} severity={alert.severity} handleClose={handleCloseAlert} />
    </div>
  );
};

Profile.propTypes = {
  onBack: PropTypes.func.isRequired,
  offerings: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  isLoadingOfferings: PropTypes.bool.isRequired,
};

export default Profile;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/Profile/Profile.js